import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import finnish from "./locales/fi.json";
import english from "./locales/en.json";
import { TTranslations, EAppLanguages } from "./@common/utils/localization";

const resources: TTranslations<typeof finnish> = {
    [EAppLanguages.FI]: { translations: finnish },
    //@ts-ignore
    [EAppLanguages.EN]: { translations: english }
};


export const initOptions: InitOptions = {
    resources: resources,
    lng: EAppLanguages.FI,
    fallbackLng: EAppLanguages.FI,
    defaultNS: "translations",
    debug: false,
    //  keySeparator: false,
    nsSeparator: ':::',
    keySeparator: '::',
    interpolation: {
        escapeValue: false // React is safe from XSS,
    },
}

i18n
    .use(initReactI18next)
    .init(initOptions);

export default i18n;